import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "edit-sub",
  "use": "edit-sub-usage",
  "viewBox": "0 0 17.84 20",
  "content": "<symbol viewBox=\"0 0 17.84 20\" id=\"edit-sub\"><title>edit-sub</title><path d=\"M2.11,16.88l3.65-1a2.23,2.23,0,0,0,.87-.5L17.92,4.09a1.07,1.07,0,0,0,0-1.47L15.59.3a1.06,1.06,0,0,0-1.47,0L2.8,11.56a2.1,2.1,0,0,0-.49.87l-1,3.72c-.13.54.21.88.75.74ZM14.86,1l2.29,2.29-.79.79L14.07,1.83ZM13.39,2.5l-.09.09,2.29,2.29L7.18,13.3,4.89,11ZM3.33,12.8a1.47,1.47,0,0,1,.24-.41l.66-.65h-.1l2.29,2.32-.56.62a1.35,1.35,0,0,1-.43.25l-2.88.71Zm15,6.12H1.63a.54.54,0,0,0-.54.54.55.55,0,0,0,.54.54H18.37a.54.54,0,0,0,0-1.09Zm0,0\" transform=\"translate(-1.08)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/edit-sub.svg
// module id = o9Fp
// module chunks = 264